// noinspection ES6ConvertVarToLetConst
import { ButtonUtils, ObjectBuilder, GridUtils, ImgButton, Rectangle3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { BroadcastManagerState, BroadcastManagerState as BMState } from "@dreamcam/web-sdk";
import { text } from "../../TextResources";
import { Settings } from "../../settings/Settings";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { ClientPanel } from "./customComponents/ClientPanel";
import { GuestPanel } from "./customComponents/GuestPanel";
// import {SubmenuEllipsis} from "./customComponents/SubmenuEllipsis";
import { SubmenuHandlers } from "./SubmenuHandlers";
import { SubmenuVolume } from "./customComponents/SubmenuVolume";
import { SubmenuClientProfile } from "./customComponents/SubmenuClientProfile";
import { AppView } from "../AppView";
import { PlayerErrors, PlayerState } from "@dreamcam/web-player-main-thread";
import { Logger } from "../../utils/Logger";
import { MessageType } from "../../interfaces/NotificationCenter";
import { waitFor } from "../../utils/AsyncUtils";
import { MessengerButton } from "./MessengerButton";
import { globalOptions } from "../../settings/GlobalOptions";
const clamp = (value, min, max) => Math.max(Math.min(value, max), min);
const rewindSeconds15 = 15;
const lowLatency = false;
export class VideoClipMenuMain {
    constructor(mesh2d, 
    // submenuEllipsisMesh: Mesh2D,
    submenuVolumeMesh, submenuClientProfileMesh, loginDialog, infoPanel, helpPanel, callbacks, messengerCallbacks, projectionMeshCallbacks) {
        this._isVisible = false;
        this._videoClip = null;
        this._isMessengerButtonOn = false;
        this._playbackProgress = null;
        this.playPauseButtonHandler = () => {
            if (this._player.state === PlayerState.STOPPED || this._player.state === PlayerState.PAUSED) {
                this._playerPlayContinueSync();
            }
            else if (this._player.state === PlayerState.PLAYING) {
                this._playerPauseSync();
            }
        };
        this.rewindButtonHandler = () => {
            if (!this._controls.rewindButton.isEnabled)
                return;
            const position = this._player.currentTime;
            const newPosition = position > rewindSeconds15 ? position - rewindSeconds15 : 0;
            this._setPlayerPosition(newPosition);
            // AppView.getInstance().appController.notificationCenter?.showMessage(MessageType.info, "rewind");
        };
        this.fastForwardButtonHandler = () => {
            if (!this._controls.fastForwardButton.isEnabled)
                return;
            const position = this._player.currentTime;
            const duration = this._player.duration;
            const newPosition = position + rewindSeconds15 > duration ? duration : position + rewindSeconds15;
            this._setPlayerPosition(newPosition);
            // AppView.getInstance().appController.notificationCenter?.showMessage(MessageType.info, "fast forward");
        };
        this._mute = (muted) => {
            this._submenuVolume.mute(muted);
            this._updateMutedButtonLayout(muted);
        };
        this._onMuteButtonEnter = () => {
            this._submenuVolume.submenuHandlers.hideSubmenuCancel();
            if (this._isVisible)
                this._submenuVolume.submenuHandlers.showSubmenu(SubmenuHandlers.longLifetime);
        };
        this._onMuteButtonOut = () => {
            this._submenuVolume.submenuHandlers.hideSubmenuCancel();
            this._submenuVolume.submenuHandlers.hideSubmenuStart(SubmenuHandlers.shortLifetime);
        };
        this._mesh2d = mesh2d;
        this._loginDialog = loginDialog;
        this._callbacks = callbacks;
        this._messengerCallbacks = messengerCallbacks;
        this._projectionMeshCallbacks = projectionMeshCallbacks;
        this._player = this._initPlayer(callbacks);
        const menu = Env.videoClip.menu;
        const mp = menu.mainPanel;
        const backgroundPanel = new Rectangle3D("videoClipMenuMainPanelContainer");
        backgroundPanel.widthInPixels = this._mesh2d.m2px(menu.width);
        backgroundPanel.heightInPixels = this._mesh2d.m2px(mp.height);
        backgroundPanel.cornerRadius = this._mesh2d.m2px(menu.cornerRadius);
        backgroundPanel.background = menu.background;
        backgroundPanel.thickness = 0;
        this._mesh2d.texture.addControl(backgroundPanel);
        // Line 1:
        {
            const l1 = mp.gridLine1;
            const gridLine1 = GridUtils.CreateGrid("gridLine1", l1.layout, this._mesh2d);
            gridLine1.widthInPixels = this._mesh2d.m2px(l1.width);
            gridLine1.heightInPixels = this._mesh2d.m2px(l1.height);
            gridLine1.leftInPixels = this._mesh2d.m2px(l1.left);
            gridLine1.topInPixels = this._mesh2d.m2px(l1.top);
            gridLine1.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            gridLine1.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
            backgroundPanel.addControl(gridLine1);
            const infoButton = ButtonUtils.CreateImgButton("videoClipMenuMainInfoButton", l1.infoButton, this._mesh2d);
            infoButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            infoButton.widthInPixels = mesh2d.m2px(l1.infoButton.width);
            infoButton.heightInPixels = mesh2d.m2px(l1.infoButton.height);
            infoButton.onClickObserver.add(() => {
                setTimeout(() => infoPanel.show(), 0);
            });
            gridLine1.addControl(infoButton, 0, 0);
            this._titleTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipMenuMainTitleTextBlock", "", l1.title);
            gridLine1.addControl(this._titleTextBlock, 0, 1);
            const helpButton = ButtonUtils.CreateImgButton("videoClipMenuMainHelpButton", l1.helpButton, this._mesh2d);
            helpButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            helpButton.widthInPixels = mesh2d.m2px(l1.helpButton.width);
            helpButton.heightInPixels = mesh2d.m2px(l1.helpButton.height);
            helpButton.onClickObserver.add(() => {
                setTimeout(() => helpPanel.show(), 0);
            });
            gridLine1.addControl(helpButton, 0, 2);
            // const ellipsisButton = ButtonUtils.CreateImgButton("videoClipMenuMainEllipsisButton", l1.ellipsisButton, this._mesh2d);
            // ellipsisButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            // ellipsisButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
            // ellipsisButton.widthInPixels = this._mesh2d.m2px(l1.ellipsisButton.width);
            // ellipsisButton.heightInPixels = this._mesh2d.m2px(l1.ellipsisButton.height);
            // ellipsisButton.onClickObserver.add(() => this._submenuEllipsis.submenuHandlers.showSubmenu(SubmenuHandlers.longLifetime));
            // gridLine1.addControl(ellipsisButton, 0, 2);
        }
        // Line 2:
        {
            const l2 = mp.gridLine2;
            const gridLine2 = GridUtils.CreateGrid("gridLine2", l2.layout, this._mesh2d);
            gridLine2.widthInPixels = this._mesh2d.m2px(l2.width);
            gridLine2.heightInPixels = this._mesh2d.m2px(l2.height);
            gridLine2.leftInPixels = this._mesh2d.m2px(l2.left);
            gridLine2.topInPixels = this._mesh2d.m2px(l2.top);
            gridLine2.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            gridLine2.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
            backgroundPanel.addControl(gridLine2);
            const exitXrButton = ButtonUtils.CreateImgButton("videoClipMenuMainexitXrButton", l2.exitXrButton, this._mesh2d);
            exitXrButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            exitXrButton.widthInPixels = this._mesh2d.m2px(l2.exitXrButton.width);
            exitXrButton.heightInPixels = this._mesh2d.m2px(l2.exitXrButton.height);
            exitXrButton.onClickObserver.add(async () => {
                await AppView.getInstance().exitXRAsync();
            });
            gridLine2.addControl(exitXrButton, 0, 0);
            const leaveButton = ButtonUtils.CreateImgButton("videoClipMenuMainLeaveButton", l2.leaveButton, this._mesh2d);
            leaveButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            leaveButton.widthInPixels = this._mesh2d.m2px(l2.leaveButton.width);
            leaveButton.heightInPixels = this._mesh2d.m2px(l2.leaveButton.height);
            leaveButton.onClickObserver.add(async () => {
                await this._callbacks.openLobbyAsync();
            });
            gridLine2.addControl(leaveButton, 0, 2);
            const libraryButton = ButtonUtils.CreateImgButton("videoClipMenuMainLibraryButton", l2.libraryButton, this._mesh2d);
            libraryButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            libraryButton.widthInPixels = this._mesh2d.m2px(l2.libraryButton.width);
            libraryButton.heightInPixels = this._mesh2d.m2px(l2.libraryButton.height);
            libraryButton.onClickObserver.add(() => {
                setTimeout(async () => {
                    const studioModel = this._videoClip === null ? null : {
                        modelId: this._videoClip.modelId,
                        modelNickname: this._videoClip.modelNickname,
                        videoClipCount: 0,
                    };
                    this._callbacks.setGalleryModel(studioModel);
                    if (studioModel !== null) {
                        AppView.getInstance().appController.scenesSwitcher.getSitePageParams().lobbyPageParams = {
                            lobbyMode: "Videos",
                            lobbyVideosMode: "AllVideos",
                        };
                    }
                    await this._callbacks.openLobbyAsync();
                }, 0);
            });
            gridLine2.addControl(libraryButton, 0, 4);
            this._statusCircle = new Rectangle3D("videoClipMenuMainStatusCircle");
            this._statusCircle.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            this._statusCircle.widthInPixels = this._mesh2d.m2px(l2.status.width);
            this._statusCircle.heightInPixels = this._mesh2d.m2px(l2.status.height);
            this._statusCircle.background = l2.status.color.live;
            this._statusCircle.thickness = 0;
            this._statusCircle.cornerRadius = Math.round(this._statusCircle.widthInPixels / 2);
            this._statusCircle.useArc = true;
            gridLine2.addControl(this._statusCircle, 0, 6);
            this._modelNicknameTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipMenuMainModelNickname", "", l2.modelNickname);
            gridLine2.addControl(this._modelNicknameTextBlock, 0, 8);
            this._liveShowButton = ButtonUtils.CreateImgButtonWithText("videoClipMenuMainLiveShowButton", {
                imageLayout: l2.liveShowButton.imageLayout,
                textLayout: l2.liveShowButton.textLayout,
                text: text.videoClip_menu_main_live_show,
            }, this._mesh2d);
            this._liveShowButton.widthInPixels = this._mesh2d.m2px(l2.liveShowButton.onlineWidth);
            this._liveShowButton.heightInPixels = this._mesh2d.m2px(l2.height);
            this._liveShowButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            this._liveShowButton.onClickObserver.add(() => {
                setTimeout(async () => {
                    if (this._modelNicknameTextBlock.text) {
                        const appView = AppView.getInstance();
                        appView.appController.sdk.galleryManager.closeVideoClip();
                        // Switch lobby to Live-mode:
                        const previousLobbyPageParams = appView.appController.scenesSwitcher.getSitePageParams().lobbyPageParams;
                        appView.appController.scenesSwitcher.setLobbyPageParams({
                            lobbyMode: "Live",
                            lobbyVideosMode: previousLobbyPageParams?.lobbyVideosMode,
                        });
                        appView.appController.scenesSwitcher.setBroadcastPageParams({
                            modelNickname: this._modelNicknameTextBlock.text,
                        });
                        await this._callbacks.openBroadcastAsync({ modelNickname: this._modelNicknameTextBlock.text });
                    }
                }, 0);
            });
            gridLine2.addControl(this._liveShowButton, 0, 10);
            this._muteButton = new ImgButton("videoClipMenuMainMuteButton", Settings.getInstance().broadcast.isSoundMuted
                ? l2.muteButton.disabledImageLayout : l2.muteButton.enabledImageLayout);
            this._muteButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            this._muteButton.widthInPixels = this._mesh2d.m2px(l2.muteButton.width);
            this._muteButton.heightInPixels = this._mesh2d.m2px(l2.muteButton.height);
            this._clearDetectPointerOnOpaqueOnly(this._muteButton);
            this._muteButton.onClickObserver.add(() => this._mute(!Settings.getInstance().broadcast.isSoundMuted));
            this._muteButton.onPointerEnterObservable.add(this._onMuteButtonEnter);
            this._muteButton.onPointerOutObservable.add(this._onMuteButtonOut);
            gridLine2.addControl(this._muteButton, 0, 12);
        }
        // Line 3:
        {
            const l3 = mp.gridLine3;
            const gridLine3 = GridUtils.CreateGrid("gridLine3", l3.layout, this._mesh2d);
            gridLine3.widthInPixels = this._mesh2d.m2px(l3.width);
            gridLine3.heightInPixels = this._mesh2d.m2px(l3.height);
            gridLine3.leftInPixels = this._mesh2d.m2px(l3.left);
            gridLine3.topInPixels = this._mesh2d.m2px(l3.top);
            gridLine3.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            gridLine3.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
            backgroundPanel.addControl(gridLine3);
            var timeOnTheLeft = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipMenuMainTimeOnTheLeft", "00:00", l3.leftText);
            gridLine3.addControl(timeOnTheLeft, 0, 0);
            const positionSliderContainer = new Container("videoClipMenuMainPositionSliderContainer");
            gridLine3.addControl(positionSliderContainer, 0, 2);
            var timeOnTheRight = ObjectBuilder.createTextBlock3D(this._mesh2d, "videoClipMenuMainTimeOnTheRight", "--:--", l3.rightText);
            gridLine3.addControl(timeOnTheRight, 0, 4);
            var positionSliderBackground = new Rectangle3D("videoClipMenuMainPositionSliderBackground");
            positionSliderBackground.zIndex = 1;
            positionSliderBackground.thickness = 0;
            positionSliderBackground.heightInPixels = this._mesh2d.m2px(l3.slider.height);
            positionSliderBackground.useArc = true;
            positionSliderBackground.cornerRadius = Math.round(positionSliderBackground.heightInPixels / 2);
            positionSliderBackground.background = l3.slider.background.color;
            positionSliderContainer.addControl(positionSliderBackground);
            var positionSliderForeground = new Rectangle3D("videoClipMenuMainPositionSliderForeground");
            positionSliderBackground.zIndex = 0;
            positionSliderForeground.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            positionSliderForeground.thickness = 0;
            var minSize = this._mesh2d.m2px(l3.slider.height);
            positionSliderForeground.heightInPixels = minSize;
            positionSliderForeground.widthInPixels = minSize;
            positionSliderForeground.useArc = true;
            positionSliderForeground.cornerRadius = Math.round(positionSliderForeground.heightInPixels / 2);
            positionSliderForeground.background = l3.slider.foreground.color;
            positionSliderContainer.addControl(positionSliderForeground);
            const setRewindPosition = (eventData) => {
                const container = positionSliderContainer;
                const localPoint = container.getLocalCoordinates(eventData);
                const progressFactor = clamp(localPoint.x / container.widthInPixels, 0, 1);
                this._setSliderPosition(progressFactor, true);
                this._setPlayerPosition(this._player.duration * progressFactor);
            };
            let rewinding = false;
            positionSliderContainer.onPointerDownObservable.add((eventData, _eventState) => {
                if (eventData.buttonIndex !== 0 || !this._controls.sliderForeground.isVisible)
                    return;
                rewinding = true;
                setRewindPosition(eventData);
            });
            positionSliderContainer.onPointerUpObservable.add((eventData, _eventStatus) => {
                if (eventData.buttonIndex !== 0)
                    return;
                rewinding = false;
            });
            positionSliderContainer.onPointerMoveObservable.add((eventData, _eventState) => {
                if (!rewinding)
                    return;
                setRewindPosition(eventData);
            });
        }
        // Line 4:
        {
            const l4 = mp.gridLine4;
            const l4_layout = globalOptions.featureMessenger ? l4.layout : l4.layoutWithoutMessenger;
            const gridLine4 = GridUtils.CreateGrid("gridLine4", l4_layout, this._mesh2d);
            gridLine4.widthInPixels = this._mesh2d.m2px(l4.width);
            gridLine4.heightInPixels = this._mesh2d.m2px(l4.height);
            gridLine4.leftInPixels = this._mesh2d.m2px(l4.left);
            gridLine4.topInPixels = this._mesh2d.m2px(l4.top);
            gridLine4.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            gridLine4.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
            backgroundPanel.addControl(gridLine4);
            this._clientPanel = new ClientPanel(this._mesh2d, { left: this._mesh2d.m2px(l4.clientPanel.left), top: this._mesh2d.m2px(l4.clientPanel.top) }, { maxWidth: this._mesh2d.m2px(l4.clientPanel.maxWidth), height: this._mesh2d.m2px(l4.clientPanel.height) });
            gridLine4.addControl(this._clientPanel.clientButton, 0, 1);
            this._clientPanel.clientButton.onClickObserver.add(() => {
                if (this._isVisible)
                    this._submenuClientProfile.submenuHandlers.showSubmenu(SubmenuHandlers.longLifetime);
            });
            this._guestPanel = new GuestPanel(this._mesh2d, { left: this._mesh2d.m2px(l4.guestPanel.left), top: this._mesh2d.m2px(l4.guestPanel.top) }, { width: this._mesh2d.m2px(l4.guestPanel.width), height: this._mesh2d.m2px(l4.guestPanel.height) }, false);
            gridLine4.addControl(this._guestPanel.rootContainer, 0, 1);
            this._guestPanel.guestButton.onClickObserver.add(async () => {
                await this._loginHandlerAsync();
            });
            var rewindButton = ButtonUtils.CreateImgButton("videoClipMenuMainRewindBackwardButton", l4.rewindButton, this._mesh2d);
            rewindButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            rewindButton.widthInPixels = this._mesh2d.m2px(l4.rewindButton.width);
            rewindButton.heightInPixels = this._mesh2d.m2px(l4.rewindButton.height);
            rewindButton.onClickObserver.add(() => this.rewindButtonHandler());
            gridLine4.addControl(rewindButton, 0, 2);
            var playButton = ButtonUtils.CreateImgButton("videoClipMenuMainPlayButton", l4.playButton.playLayout, this._mesh2d);
            playButton.changeLayout(l4.playButton.pauseLayout);
            playButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            playButton.widthInPixels = this._mesh2d.m2px(l4.playButton.width);
            playButton.heightInPixels = this._mesh2d.m2px(l4.playButton.height);
            playButton.onClickObserver.add(() => this.playPauseButtonHandler());
            gridLine4.addControl(playButton, 0, 4);
            var fastForwardButton = ButtonUtils.CreateImgButton("videoClipMenuMainRewindForwardButton", l4.fastForwardButton, this._mesh2d);
            fastForwardButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
            fastForwardButton.widthInPixels = this._mesh2d.m2px(l4.fastForwardButton.width);
            fastForwardButton.heightInPixels = this._mesh2d.m2px(l4.fastForwardButton.height);
            fastForwardButton.onClickObserver.add(async () => this.fastForwardButtonHandler());
            gridLine4.addControl(fastForwardButton, 0, 6);
            const getTokensButton = ButtonUtils.CreateImgButtonWithText("videoClipMenuMainGetTokensButton", {
                imageLayout: l4.getTokensButton.imageLayout,
                textLayout: l4.getTokensButton.textLayout,
                text: text.broadcast_menu_tipMenu_message_topUp_button,
            }, this._mesh2d);
            getTokensButton.heightInPixels = this._mesh2d.m2px(l4.height);
            getTokensButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
            getTokensButton.onClickObserver.add(async () => {
                await AppView.getInstance().topUpAsync();
            });
            gridLine4.addControl(getTokensButton, 0, 7);
            var messengerButton = MessengerButton.create(this._mesh2d);
            messengerButton.messengerButton.onClickObserver.add(() => setTimeout(() => this.isMessengerButtonOn = !this.isMessengerButtonOn));
            if (globalOptions.featureMessenger) {
                gridLine4.addControl(messengerButton.messengerButton, 0, 9);
            }
        }
        this._submenuVolume = new SubmenuVolume(submenuVolumeMesh, {
            getMuted: this._callbacks.getPlayerSoundMuted,
            setMuted: muted => {
                this._callbacks.setPlayerSoundMuted(muted);
                this._updateMutedButtonLayout(muted);
            },
            getVolume: this._callbacks.getPlayerSoundVolume,
            setVolume: volume => this._callbacks.setPlayerSoundVolume(volume),
        }, {
            update: (muted) => this._updateMutedButtonLayout(muted),
        });
        this._submenuClientProfile = new SubmenuClientProfile(submenuClientProfileMesh, {
            signout: () => {
                setTimeout(async () => {
                    this._submenuClientProfile.submenuHandlers.hideSubmenuInstantly();
                    await AppView.getInstance().appController.sdk.authManager.logoutAsync();
                    if (AppView.getInstance().isApiAuth) {
                        await AppView.getInstance().logoutApiAuthAsync();
                    }
                    else if (AppView.getInstance().logoutAsync) {
                        await AppView.getInstance().logoutAsync();
                    }
                }, 0);
            },
        });
        this._controls = {
            sliderBackground: positionSliderBackground,
            sliderForeground: positionSliderForeground,
            positionTextBlock: timeOnTheLeft,
            durationTextBlock: timeOnTheRight,
            rewindButton: rewindButton,
            fastForwardButton: fastForwardButton,
            playButton,
            messengerButton: messengerButton.messengerButton,
            unreadMessagesCountContainer: messengerButton.unreadMessagesCountContainer,
            unreadMessagesCountTextBlock: messengerButton.unreadMessagesCountTextBlock,
            data: {
                sliderForegroundMinWidthInPixels: minSize,
                previousForegroundWidthInPixels: null,
            },
        };
    }
    async _loginHandlerAsync() {
        if (this._loginDialog)
            this._loginDialog.show("signIn");
        else if (AppView.getInstance().loginAsync)
            await AppView.getInstance().loginAsync();
    }
    get isVisible() {
        return this._isVisible;
    }
    get isMessengerButtonOn() {
        return this._isMessengerButtonOn;
    }
    set isMessengerButtonOn(value) {
        if (value === this._isMessengerButtonOn)
            return;
        // if (value) this.turnAllTogglersOff();
        const isMessengerAuthorized = AppView.getInstance().appController.messengerSdk.authManager.isAuthorized;
        if (value && (this._guestPanel.rootContainer.isVisible || !isMessengerAuthorized)) {
            setTimeout(async () => await this._loginHandlerAsync());
            return;
        }
        this._isMessengerButtonOn = value;
        const mb = Env.common.messengerButton;
        this._controls.messengerButton.changeLayout(value ? mb.activeImageLayout : mb.inactiveImageLayout);
        if (value) {
            this._messengerCallbacks.showMessengerDialog();
        }
        else {
            this._messengerCallbacks.hideMessengerDialog();
        }
    }
    show() {
        this._isVisible = true;
        this._updateMutedButtonLayout(Settings.getInstance().broadcast.isSoundMuted);
        this.updateInfoButtonLayout();
        this._submenuVolume.refreshVolume();
        this._hideAllSubmenus();
    }
    hide() {
        this._isVisible = false;
        this._hideAllSubmenus();
    }
    outputMessengerLoggedState(isAuthorized) {
        if (!isAuthorized) {
            this.outputUnreadMessagesCount([]);
            this.isMessengerButtonOn = false;
        }
        // this._controls.messengerButton.isEnabled = isAuthorized;
    }
    outputUnreadMessagesCount(unreadChats) {
        const totalUnreadCount = unreadChats.reduce((sum, chat) => sum + chat.unread_count, 0);
        this._controls.unreadMessagesCountContainer.isVisible = totalUnreadCount > 0.001;
        const maxUnread = globalOptions.messengerMaxUnreadCount;
        this._controls.unreadMessagesCountTextBlock.text = totalUnreadCount > maxUnread ? `${maxUnread}+` : totalUnreadCount.toString();
    }
    _setPlayerButtonsState(enabled, playButtonLayout) {
        const vc = this._videoClip;
        if (vc === null || (!vc.isFree && vc.product?.isPurchased !== true))
            enabled = false;
        this._controls.rewindButton.isEnabled = enabled;
        this._controls.fastForwardButton.isEnabled = enabled;
        this._controls.playButton.isEnabled = enabled;
        this._controls.playButton.changeLayout(playButtonLayout);
        // this._controls.sliderForeground.isVisible = enabled;
    }
    ;
    _initPlayer(callbacks) {
        const result = callbacks.getPlayer();
        const appController = AppView.getInstance().appController;
        result.addEventListener("statechanged", e => {
            const states = e.detail;
            if (this._videoClip === null)
                return;
            const state = states.newState;
            const pb = Env.videoClip.menu.mainPanel.gridLine4.playButton;
            switch (state) {
                case PlayerState.STOPPED:
                case PlayerState.PAUSED:
                    this._setPlayerButtonsState(true, pb.playLayout);
                    break;
                case PlayerState.PLAYING:
                    this._setPlayerButtonsState(true, pb.pauseLayout);
                    break;
                case PlayerState.STALLING:
                    this._setPlayerButtonsState(false, pb.pauseLayout);
                    break;
                case PlayerState.PREPARING:
                    this._setPlayerButtonsState(false, pb.playLayout);
                    break;
            }
        });
        result.addEventListener("timeupdate", () => {
            if (this._videoClip === null)
                return;
            const videoUrl = this._playbackProgress?.videoUrl ?? null;
            const positionInSeconds = Math.floor(this._player.currentTime);
            const newPosition = this._playbackProgress === null || positionInSeconds !== this._playbackProgress?.positionInSeconds;
            const durationInSeconds = Math.floor(this._player.duration);
            const newDuration = this._playbackProgress === null || durationInSeconds !== this._playbackProgress?.durationInSeconds;
            const playbackPositionFormat = durationInSeconds > 3600 ? "hh:mm:ss" : "mm:ss";
            const newFormat = this._playbackProgress === null || playbackPositionFormat !== this._playbackProgress?.playbackPositionFormat;
            this._playbackProgress = { videoUrl, positionInSeconds, durationInSeconds, playbackPositionFormat };
            if (newPosition || newFormat) {
                this._controls.positionTextBlock.text = this._secondsToTime(positionInSeconds, playbackPositionFormat);
            }
            if (newDuration || newFormat) {
                this._controls.durationTextBlock.text = this._secondsToTime(durationInSeconds, playbackPositionFormat);
            }
            this._setSliderPosition(this._player.currentTime / this._player.duration, false);
        });
        result.addEventListener("error", async (e) => {
            if (this._videoClip === null)
                return;
            // console.log(`%c++++ VideoClip URL update => code: ${code}, message: ${message}, errorData: ${JSON.stringify(errorData)}`, "background-color: gold");
            const code = e.detail?.error;
            const message = e.detail?.message ?? "";
            if (code === PlayerErrors.UNAUTHORIZED && appController.sdk.galleryManager.videoClip !== null) {
                const videoClipId = appController.sdk.galleryManager.videoClip.id;
                let newVideoUrl = null;
                try {
                    const videoClipStreamData = await appController.sdk.galleryManager.reloadVideoClipStreamDataAsync(videoClipId);
                    newVideoUrl = videoClipStreamData.url;
                }
                catch (e) {
                    Logger.error(`Player [${code}]: ${message}`);
                    appController.notificationCenter?.showMessage(MessageType.error, message);
                }
                if (newVideoUrl === null) {
                    await result.stop();
                }
                else {
                    result.src = newVideoUrl;
                    result.lowLatency = false;
                    await result.play();
                }
                // if (result.state === PlayerState.PLAYING ||
                //     result.state === PlayerState.PREPARING ||
                //     result.state === PlayerState.STALLING
                // ) {
                //     if (newVideoUrl === null) {
                //         await result.stop();
                //     } else {
                //         console.log(`%c++++ ${newVideoUrl}  +++++++ ${errorData.lastTimestamp}`, "background-color: coral");
                //         await result.play(newVideoUrl, false, errorData.lastTimestamp);
                //     }
                // }
            }
            else {
                Logger.error(`Player [${code}]: ${message}`);
                appController.notificationCenter?.showMessage(MessageType.error, message);
            }
        });
        // result.on(PlayerEvent.WARNING, (code: PlayerErrors, message: string) => {
        //     if (code !== PlayerErrors.UNAUTHORIZED) {
        //         Logger.warning(`Player [${code}]: ${message}`)
        //     }
        // });
        return result;
    }
    _setSliderPosition(progressFactor, force) {
        const widthInPixels = clamp(Math.round(this._controls.sliderBackground.widthInPixels * progressFactor), this._controls.data.sliderForegroundMinWidthInPixels, this._controls.sliderBackground.widthInPixels);
        const canSetWidth = force ||
            this._controls.data.previousForegroundWidthInPixels === null ||
            widthInPixels !== this._controls.data.previousForegroundWidthInPixels;
        if (canSetWidth) {
            this._controls.sliderForeground.widthInPixels = widthInPixels;
            this._controls.data.previousForegroundWidthInPixels = widthInPixels;
        }
    }
    _setPlayerPosition(seconds) {
        this._playerSeekSync(clamp(seconds, 0, this._player.duration));
    }
    // private _playerWait: boolean = false;
    _callPlayerMethodSync(func) {
        (async () => {
            // await waitFor(() => !this._playerWait, 5000, {logErrorOnTimeout: true, rejectOnTimeout: false});
            // this._playerWait = true;
            try {
                await func();
            }
            catch (e) {
                console.error(e);
            }
            finally {
                // this._playerWait = false;
            }
        })();
    }
    _playerStopSync() {
        this._callPlayerMethodSync(async () => await this._player.stop());
    }
    _playerPauseSync() {
        this._callPlayerMethodSync(async () => await this._player.pause());
    }
    _playerPlaySync(url, timestamp) {
        this._callPlayerMethodSync(async () => await this._playAfterFadingOutAsync(url, lowLatency, timestamp));
    }
    async _playAfterFadingOutAsync(url, lowLatency, _timestamp) {
        this._setSliderPosition(0, true);
        const fadingHelper = AppView.getInstance().fadingHelper;
        await waitFor(() => fadingHelper === undefined || !fadingHelper.isBlocked, 10_000, { logErrorOnTimeout: true, rejectOnTimeout: false });
        this._player.src = url;
        this._player.lowLatency = lowLatency ?? false;
        // await this._player.play(url, lowLatency, timestamp);
        await this._player.play();
    }
    _playerPlayContinueSync() {
        this._callPlayerMethodSync(async () => {
            if (this._playbackProgress && this._playbackProgress.videoUrl) {
                if (this._player.state === PlayerState.PAUSED) {
                    // await this._player.resume();
                    await this._player.play();
                }
                else {
                    const timestamp = Math.abs(this._player.currentTime - this._player.duration) < 0.1
                        ? undefined
                        : this._player.currentTime;
                    await this._playAfterFadingOutAsync(this._playbackProgress.videoUrl, lowLatency, timestamp);
                }
            }
        });
    }
    _playerSeekSync(seconds) {
        this._callPlayerMethodSync(async () => await this._player.seek(seconds));
    }
    _hideAllSubmenus() {
        // this._submenuEllipsis.submenuHandlers.hideSubmenuInstantly();
        this._submenuVolume.submenuHandlers.hideSubmenuInstantly();
        this._submenuClientProfile.submenuHandlers.hideSubmenuInstantly();
    }
    _updateMutedButtonLayout(muted) {
        const sl = Env.videoClip.menu.mainPanel.gridLine2.muteButton;
        this._muteButton.changeLayout(muted ? sl.disabledImageLayout : sl.enabledImageLayout);
    }
    _clearDetectPointerOnOpaqueOnly(imgButton) {
        imgButton.children[0].detectPointerOnOpaqueOnly = false;
    }
    _secondsToTime(seconds, format) {
        const h = Math.floor(seconds / 60 / 60);
        const m = Math.floor((seconds - h * 60 * 60) / 60);
        const s = Math.floor(seconds - h * 60 * 60 - m * 60);
        let hh;
        switch (format) {
            case "mm:ss":
                hh = "";
                break;
            case "hh:mm:ss":
                hh = h >= 0 && h < 10 ? `0${h}:` : `${h}:`;
                break;
            default:
                hh = h === 0 ? "" : (h > 0 && h < 10 ? `0${h}:` : `${h}:`);
                break;
        }
        const mm = m >= 0 && m < 10 ? `0${m}:` : `${m}:`;
        const ss = s >= 0 && s < 10 ? `0${s}` : `${s}`;
        return `${hh}${mm}${ss}`;
    }
    ;
    updateInfoButtonLayout() {
        // const l2 = Env.videoClip.menu.mainPanel.gridLine2;
        // this._infoButton.changeLayout(this._infoPanel.isVisible ? l2.infoButton.activeInfoPanel : l2.infoButton.inactiveInfoPanel);
    }
    stateChanged(state, _isGuest, _reason) {
        if (state === BMState.UNINITIALIZED)
            return;
        this._statusCircle.background = VideoClipMenuMain._statusMap[state];
        const isOffline = state === BMState.OFFLINE;
        for (let child of this._liveShowButton.children) {
            if (child.name === `${this._liveShowButton.name}_text`) {
                child.text = isOffline ? text.videoClip_menu_main_offline_show : text.videoClip_menu_main_live_show;
                break;
            }
        }
        const btn = Env.videoClip.menu.mainPanel.gridLine2.liveShowButton;
        this._liveShowButton.widthInPixels = this._mesh2d.m2px(isOffline ? btn.offlineWidth : btn.onlineWidth);
    }
    outputVideoClip(videoClip) {
        this._videoClip = videoClip;
        // this._priceTextBlock.text = `${this._videoClip?.product?.productPrice ?? 0} ${text.tokensShortName}`;
        this._titleTextBlock.text = this._videoClip?.title ?? "";
        this._modelNicknameTextBlock.text = this._videoClip?.modelNickname ?? "";
        this._controls.positionTextBlock.text = this._secondsToTime(0, "mm:ss");
        const unknownDuration = "--:--";
        let durationText;
        if (videoClip === null) {
            this._playbackProgress = null;
            durationText = unknownDuration;
        }
        else {
            const durationInSeconds = Math.floor(videoClip.duration);
            const playbackPositionFormat = durationInSeconds > 3600 ? "hh:mm:ss" : "mm:ss";
            durationText = this._videoClip === null ? unknownDuration : this._secondsToTime(durationInSeconds, playbackPositionFormat);
            const positionInSeconds = this._playbackProgress !== null && this._playbackProgress.positionInSeconds !== null
                ? this._playbackProgress.positionInSeconds
                : null;
            this._playbackProgress = {
                videoUrl: null,
                positionInSeconds,
                durationInSeconds,
                playbackPositionFormat,
            };
        }
        // durationText = "12:34:56";
        this._controls.durationTextBlock.text = durationText;
        const videoUrl = videoClip?.videoUrl ?? null;
        if (this._playbackProgress)
            this._playbackProgress.videoUrl = videoUrl;
        if (videoUrl === null) {
            this._setPlayerButtonsState(false, Env.videoClip.menu.mainPanel.gridLine4.playButton.playLayout);
            this._playerStopSync();
        }
        else {
            this._projectionMeshCallbacks.prepareProjection(videoUrl);
            this._playerPlaySync(videoUrl);
        }
        this._controls.sliderForeground.isVisible = videoUrl !== null;
    }
    outputClientInfo(isGuest) {
        this._guestPanel.rootContainer.isVisible = isGuest;
        this._clientPanel.clientButton.isVisible = !isGuest;
    }
    outputClientNickname(nickname) {
        this._clientPanel.nicknameTextBlock.text = nickname;
    }
    outputClientBalance(tokens) {
        this._clientPanel.balanceAmountTextBlock.text = tokens.toLocaleString("ru", {});
    }
}
VideoClipMenuMain._statusMap = {
    [BroadcastManagerState.AWAY]: Env.videoClip.menu.mainPanel.gridLine2.status.color.away,
    [BroadcastManagerState.PRIVATE_SHOW]: Env.videoClip.menu.mainPanel.gridLine2.status.color.private,
    [BroadcastManagerState.MY_PRIVATE_SHOW]: Env.videoClip.menu.mainPanel.gridLine2.status.color.private,
    [BroadcastManagerState.SPY_SHOW]: Env.videoClip.menu.mainPanel.gridLine2.status.color.private,
    [BroadcastManagerState.PUBLIC]: Env.videoClip.menu.mainPanel.gridLine2.status.color.live,
    [BroadcastManagerState.OFFLINE]: Env.videoClip.menu.mainPanel.gridLine2.status.color.offline,
};
